/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { OfficeEntityPermissionNode } from '@gh/builder-shared-data';
import { CheckboxTreeNode } from '@gh/common-internal-shared';

export function buildCheckboxTreeModel<T extends OfficeEntityPermissionNode>(roots: T[],
                                                                             // tslint:disable-next-line:max-line-length
                                                                             predicate?: PredicateFn<T>): CheckboxTreeNode<T>[] {
  if (!predicate) {
    predicate = () => true;
  }

  return roots.filter(predicate).map((node) => buildNodeModel(node, void 0, <any>predicate));
}

export function processEntityTree<T extends OfficeEntityPermissionNode>(node: T, fn: (node: T) => void): void {
  fn(node);

  if (node.children && node.children.length > 0) {
    node.children.forEach((child) => processEntityTree(child, fn));
  }
}

export function processModelSubtree<T>(anchor: CheckboxTreeNode<T>, fn: (node: CheckboxTreeNode<T>) => void): void {
  fn(anchor);

  // process parent
  let parent = anchor.parent;
  while (parent) {
    fn(parent);

    parent = parent.parent;
  }

  // process children
  if (anchor.children) {
    anchor.children.forEach((child) => processModelSubtree(child, fn));
  }
}

function buildNodeModel<T extends OfficeEntityPermissionNode>(node: T,
                                                              parent: Maybe<CheckboxTreeNode<T>>,
                                                              predicate: PredicateFn<T>): CheckboxTreeNode<T> {
  const model = new CheckboxTreeNode(node.name, node, node.allowed, false, parent, void 0, node.code);

  if (node.children && node.children.length > 0) {
    model.children = node.children.filter(predicate).map((child) => buildNodeModel(child, model, predicate));
  }

  return model;
}
